var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    class: {
      loaded: _vm.loaded
    }
  }, [_c('loading-overlay', {
    attrs: {
      "tracking": {
        class: 'contact'
      }
    },
    model: {
      value: _vm.loaded,
      callback: function ($$v) {
        _vm.loaded = $$v;
      },
      expression: "loaded"
    }
  }), _vm._v(" "), _vm._m(0)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "pt-40 sm-md:pt-32 contact--section effect--fade-slide-in"
  }, [_c('div', {
    staticClass: "section--container section--container-page"
  }, [_c('div', {
    staticClass: "container section--content"
  }, [_c('h1', [_vm._v("Get in touch")]), _vm._v(" "), _c('h4', [_vm._v("CURRENT EXTRA MEMBERS")]), _vm._v(" "), _c('div', {
    staticClass: "text-lead bold"
  }, [_c('ul', {
    staticClass: "mt-2"
  }, [_c('li', {
    staticClass: "mt-1"
  }, [_vm._v("Visit our "), _c('a', {
    attrs: {
      "href": "https://help.extra.app/en"
    }
  }, [_vm._v("Support Center")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "mt-1"
  }, [_vm._v("\n\t\t\t\t\t\t\tChat with us in the Extra App\n\t\t\t\t\t\t")]), _vm._v(" "), _c('li', {
    staticClass: "mt-1"
  }, [_vm._v("Email: "), _c('a', {
    attrs: {
      "href": "mailto:hey@extra.app"
    }
  }, [_vm._v("hey@extra.app")])]), _vm._v(" "), _c('li', {
    staticClass: "mt-1"
  }, [_vm._v("Call: 833-984-2291")]), _vm._v(" "), _c('li', {
    staticClass: "mt-1"
  }, [_vm._v("Mail: 9450 SW Gemini Drive, PMB 16167, Beaverton, OR 97008-7105")])])]), _vm._v(" "), _c('div', {
    staticClass: "text-lead bold"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("\n\t\t\t\t\t\tLost or Stolen Extra Card/PIN:\n\t\t\t\t\t")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-2"
  }, [_c('li', {
    staticClass: "mt-1"
  }, [_vm._v("Freeze your card in-app and contact Member Concierge, or")]), _vm._v(" "), _c('li', {
    staticClass: "mt-1"
  }, [_vm._v("Call 833-984-2291 or the number on the back of your card for replacement.")])])]), _vm._v(" "), _c('div', {
    staticClass: "text-lead bold"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("\n\t\t\t\t\t\tIf your Extra Account has been compromised:\n\t\t\t\t\t\t"), _c('ul', {
    staticClass: "mt-2"
  }, [_c('li', {
    staticClass: "mt-1"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tEmail: "), _c('a', {
    attrs: {
      "href": "mailto:fraudsupport@extra.app"
    }
  }, [_vm._v("fraudsupport@extra.app")])])])])]), _vm._v(" "), _c('hr', {
    staticClass: "sm-md:my-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-24 sm-md:flex-col sm-md:space-x-0 sm-md:space-y-10"
  }, [_c('div', [_c('h4', {
    staticClass: "mt-0 mb-4 sm-md:mb-1"
  }, [_vm._v("FUTURE EXTRA MEMBERS")]), _vm._v(" "), _c('a', {
    staticClass: "text-lead",
    attrs: {
      "href": "mailto:hey@extra.app"
    }
  }, [_vm._v("hey@extra.app")])]), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "mt-0 mb-4 sm-md:mb-1"
  }, [_vm._v("PRESS INQUIRIES")]), _vm._v(" "), _c('a', {
    staticClass: "text-lead",
    attrs: {
      "href": "mailto:press@extra.app"
    }
  }, [_vm._v("press@extra.app")])]), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "mt-0 mb-4 sm-md:mb-1"
  }, [_vm._v("PARTNERSHIPS")]), _vm._v(" "), _c('a', {
    staticClass: "text-lead",
    attrs: {
      "href": "mailto:partnerships@extra.app"
    }
  }, [_vm._v("partnerships@extra.app")])])])])])]);
}];
export { render, staticRenderFns };